// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2wyef","colCheckbox":"styles_colCheckbox__HjI4z"};